import React, { useContext, useEffect } from 'react';
import { number, string, bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { Heading } from '@thd-olt-component-react/heading';
import { SEOContent } from './SEOContent';
import './questions-and-answers.style.scss';
import { dataModel } from './dataModel';
import {
  initializeScriptsAndListeners,
  qAndAURL,
  removePaginationEventListeners,
  smoothScroll
} from './BVHelpers';

export const QuestionsAndAnswersDesktop = ({ itemId, startindex, pagesize, conversations }) => {
  const experienceContext = useContext(ExperienceContext);
  const { hosts } = experienceContext;
  const {
    ugc = 'https://homedepot.ugc.bazaarvoice.com',
    bazaarVoiceApps = 'https://apps.bazaarvoice.com/deployments/homedepot/main_site/production'
  } = hosts || {};

  useEffect(() => {
    const url = qAndAURL({ conversations, bvHost: bazaarVoiceApps, ugcHost: ugc });
    initializeScriptsAndListeners({ conversations, itemId, url });
    return function cleanup() {
      removePaginationEventListeners(smoothScroll);
    };
  }, [itemId]);

  const { data, error, loading } = useDataModel('product', { variables: { itemId } });
  const QandA = useDataModel('questionsAnswers', { variables: { itemId, startindex, pagesize } });

  const qaData = (QandA || {}).data;
  const qaError = (QandA || {}).error;
  const qaLoading = (QandA || {}).loading;

  const renderNull = (qaError && !qaData) || !qaData || qaLoading;

  if (!data || (error && !data) || loading || renderNull) {
    return null;
  }
  const { product } = data || {};
  const { productLabel } = (product || {}).identifiers || {};
  const { questionsAnswers } = qaData || null;

  if (!questionsAnswers) {
    return null;
  }

  return (
    <div id="questions_answers_full" className="grid questions-and-answers">
      <div className="qa-wrapper">
        <Heading title="Questions & Answers" underline />
        <div id="BVQAContainer">
          <div className="questions-and-answers__seo-content">
            <SEOContent questionsAnswers={questionsAnswers} itemId={itemId} productLabel={productLabel} />
          </div>
        </div>
      </div>
    </div>
  );
};

QuestionsAndAnswersDesktop.displayName = 'QuestionsAndAnswersDesktop';

QuestionsAndAnswersDesktop.dataModel = dataModel;

QuestionsAndAnswersDesktop.propTypes = {
  itemId: string.isRequired,
  startindex: number,
  pagesize: number,
  conversations: bool
};

QuestionsAndAnswersDesktop.defaultProps = {
  startindex: 1,
  pagesize: 10,
  conversations: false
};
